import { External, Tag } from "components/icons/generated";

import TableCellLink, { TableCellLinkProps } from "./CellLink";

type TableCellGitTagProps = TableCellLinkProps;

const TableCellGitTag = (props: TableCellGitTagProps) => {
  return (
    <TableCellLink
      variant="primary"
      target="_blank"
      startIcon={Tag}
      endIcon={External}
      {...props}
    />
  );
};

TableCellGitTag.displayName = "DS.Table.CellGitTag";

export default TableCellGitTag;
